import React from 'react'
import Feature from '../images/features/features.png'
import Icon1 from  '../images/features/icon (1).png'
import Icon2 from  '../images/features/icon (2).png'
import Icon3 from  '../images/features/icon (3).png'
const FeatureContainer = () => {
  return (
    
<section class="pb-16">
    <div class="mx-auto max-w-7xl px-8 md:px-6">
        {/* <!-- heading text --> */}
        <div class="mb-5 sm:mb-10">
            <span class="font-medium text-blue-500">Our Features</span>
            <h1 class="text-2xl font-bold text-slate-700 sm:text-3xl">Provide Our Features</h1>
        </div>
        {/* <!-- features img --> */}
        <div class="md:flex md:justify-between md:gap-6 xl:gap-10">
            <div class="mb-5 max-h-[600px] overflow-hidden rounded-lg md:mb-0 md:w-5/12">
                <img src={Feature} alt="features img" class="h-full scale-125 sm:w-full sm:object-cover" />
            </div>
            <div class="md:w-7/12">
                <div class="mb-16 flex flex-col">
                    <p class="mb-3 text-slate-500">Lorem ipsum dolor sit amet consectetur adipisicing elit. Sint explicabo perferendis voluptatibus sunt enim officiis.</p>

                    <p class="mb-10 text-slate-500">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Sint laudantium, cum, quaerat nulla possimus magni odio ullam ratione vitae id fuga aliquam sed molestiae? Voluptas.</p>

                    <button class="w-full rounded-md bg-blue-500 px-8 py-2.5 font-semibold text-white shadow-md shadow-blue-500/20 hover:bg-blue-600 duration-200 md:w-max">Get Started</button>
                </div>

                <div class="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
                    <div class="flex flex-col items-center justify-center rounded-xl bg-white px-4 py-8 shadow-lg">
                        <img class="mb-3 w-16" src={Icon1} alt="" />
                        <h3 class="text-lg font-bold text-slate-600">Web Design</h3>
                        <a href="#" class="text-sm text-blue-500">Learn more</a>
                    </div>
                    <div class="flex flex-col items-center justify-center rounded-xl bg-white px-4 py-8 shadow-lg">
                        <img class="mb-3 w-16" src={Icon2} alt="" />
                        <h3 class="text-lg font-bold text-slate-600">Automation</h3>
                        <a href="#" class="text-sm text-blue-500">Learn more</a>
                    </div>
                    <div class="flex flex-col items-center justify-center rounded-xl bg-white px-4 py-8 shadow-lg">
                        <img class="mb-3 w-16" src={Icon3} alt="" />
                        <h3 class="text-lg font-bold text-slate-600">Infographics</h3>
                        <a href="#" class="text-sm text-blue-500">Learn more</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

  )
}

export default FeatureContainer